import React from "react";
import { Box, Flex } from "theme-ui";
import ActionRequiredBanner from "./ActionRequiredBanner";
import ExpirationStatsWidget from "./ExpirationStatsWidget";
import PipelineMetricsWidget from "./PipelineMetricsWidget";
import KPICards from "./KPICards";
import RevenueTrendChart from "./RevenueTrendChart";
import PipelineFunnel from "./PipelineFunnel";
import RecentActivityFeed from "./RecentActivityFeed";
import ActionItems from "./ActionItems";
import OutstandingDepositsWidget from "./OutstandingDepositsWidget";
import ActivePriceLocksWidget from "./ActivePriceLocksWidget";

const AdminDashboard: React.FC = () => {
  return (
    <Box>
      {/* Action Required Alert Banner */}
      <ActionRequiredBanner dashboardType="admin" />

      {/* KPI Cards */}
      <KPICards />

      {/* Charts Row */}
      <Flex sx={{ gap: "16px", flexWrap: "wrap", marginBottom: "24px", alignItems: "stretch" }}>
        <RevenueTrendChart />
        <PipelineFunnel />
      </Flex>

      {/* Expiration Intelligence */}
      <ExpirationStatsWidget />

      {/* Pipeline Health Metrics */}
      <PipelineMetricsWidget />

      {/* Outstanding Deposit Credits */}
      <OutstandingDepositsWidget />

      {/* Active Price Locks */}
      <ActivePriceLocksWidget />

      {/* Activity Row */}
      <Flex sx={{ gap: "16px", flexWrap: "wrap", alignItems: "stretch" }}>
        <RecentActivityFeed />
        <ActionItems />
      </Flex>
    </Box>
  );
};

export default AdminDashboard;
